import { findOption } from "../utils"

const renderSchoolGroup = (schoolOptions, searchFor, label) => {
  const regex = new RegExp(searchFor)
  const schools = schoolOptions.filter((option) => {
    return option.value2.match(regex)
  })

  return (
    <optgroup label={label}>
      {schools.map(function (school) {
        return (
          <option key={school.label} value={school.id}>
            {school.label}
          </option>
        )
      })}
    </optgroup>
  )
}

export const renderSchoolGroupOptions = (schoolOptions, included) => {
  let schools = schoolOptions.data.map((schoolOption) => {
    let school = findOption({ ...schoolOption, included })

    return {
      id: schoolOption.id,
      label: school.attributes.label,
      value2: school.attributes.value2,
    }
  })

  return (
    <>
      {renderSchoolGroup(schools, "elementary", "Elementary schools")}
      {renderSchoolGroup(schools, "middle_school", "Middle Schools")}
      {renderSchoolGroup(schools, "high_school", "High Schools")}
      {renderSchoolGroup(schools, "college", "Colleges")}
      {renderSchoolGroup(schools, "other", "Other")}
    </>
  )
}

export const genderOptions = (genders = {}, included) => {
  return genders.data.map((o) => {
    const {
      id,
      attributes: { value },
    } = findOption({ ...o, included })
    return (
      <option key={id} value={id}>
        {value}
      </option>
    )
  })
}
